import {
  SBAsyncSelect,
  SBAsyncSelectProps,
} from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Col, Form, Input, InputNumber, Row } from 'antd'
import { requiredRule } from '../../../utils/rules'
import { Localizable } from '../../localizable/Localizable'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  // Sub-venues cannot belong to a cluster.
  const venuesQuery: SBAsyncSelectProps['initialQuery'] = {
    ...initialQuery,
    filters: { ...initialQuery.filters, excludeSubVenues: [true] },
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="name" rules={[requiredRule()]} label={'Private name'}>
        <Input required />
      </Form.Item>
      <Localizable.Input
        name="title"
        rules={[requiredRule()]}
        label={'Title'}
        max={70}
      />
      <Form.Item name="venues" rules={[requiredRule()]} label={'Venues'}>
        <SBAsyncSelect
          entity={Entity.venue}
          multiple
          initialQuery={venuesQuery}
          searchFieldName="name"
          allowClear
        />
      </Form.Item>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            name="latitude"
            rules={[requiredRule()]}
            label={'Latitude'}
          >
            <InputNumber min={-90} max={90} required className="w-full" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="longitude"
            rules={[requiredRule()]}
            label={'Longitude'}
          >
            <InputNumber
              min={-180}
              max={180}
              required
              className="w-full"
              stringMode
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Create
